import { GameDescription } from "../model/game-description";

export enum Direction {
    east = 'east',
    west = 'west',
    north = 'north',
    south = 'south'
}

export enum CardSuit {
    clubs = 'Clubs',
    spades = 'Spades',
    diamonds = 'Diamonds',
    hearts = 'Hearts'
}
  
export enum CardValue {
    ace='Ace',
    two='Two',
    three='Three',
    four='Four',
    five='Five',
    six='Six',
    seven='Seven',
    eight='Eight',
    nine='Nine',
    ten='Ten',
    jack='Jack',
    queen='Queen',
    king='King'
}

export interface CardInfo {
    suit: CardSuit;
    value: CardValue;
}

export interface CardInfoWithId {
    id: string;
    suit: CardSuit;
    value: CardValue;
}

export enum CardShift {
    OPEN = 0, CLOSED = 1, SHUT = 2
}

export interface CardModel {
    readonly id: string;
    readonly suit: CardSuit;
    readonly value: CardValue;
    readonly faceUp: boolean;
    readonly shift: CardShift;
}

export interface PileCardModel {
    readonly id: string;
    readonly draggable: boolean;
}

export interface PileModel {
    readonly id: string;
    readonly row: number;
    readonly col: number;
    readonly direction: Direction;
    readonly clickable: boolean;
    readonly cards: PileCardModel[];
}

export interface BoardModel {
    readonly rows: number;
    readonly cols: number;
    readonly pileIds: string[];
}

export interface GameModel {
    setupBoard(description: GameDescription): void;
    subscribeGameState(handler: (win: boolean) => void): void;
    subscribeBoardModel(handler: (board: BoardModel) => void): void;
    subscribePileModel(pileId: string, handler: (pile: PileModel) => void): void;
    getPiledModel(pileId: string): PileModel;
    getCardModel(cardId: string): CardModel;
    dropPile(destPileId: string, sourcePileId: string, cardId: string): boolean;
    clickPile(pileId: string): void
}